import { Spinner } from "components/Spinner";
import Icon from "ds/components/Icon";

import styles from "./styles.module.css";

const FormLoading = () => (
  <section className={styles.form}>
    <section className={styles.body}>
      <Icon src={Spinner} size="x-large" />
    </section>
  </section>
);

export default FormLoading;
